import {create} from "zustand"
import {shallow} from "zustand/shallow"

export type FamilyOption = "Kinderwunsch" | "Schwangerschaft" | "Stillzeit" | ""

interface State {
    topicForbiddenFoods: boolean
    topicSuperfoods: boolean
    topicNausea: boolean
    topicSupplements: boolean
    topicSport: boolean
    topicVegetarian: boolean
    topicVegan: boolean
    topicWeight: boolean
    topicEasyBirth: boolean
    textWorkValue: string
    textareaValue: string
    familyOption: FamilyOption
    name: string
    email: string
    email_contact: boolean
    newsletter: boolean
}

interface FullState extends State {
    setFormData: (name: string, value: string | boolean | FamilyOption) => void
}

const useStore = create<FullState>((set, get) => ({
    topicForbiddenFoods: false,
    topicSuperfoods: false,
    topicNausea: false,
    topicSupplements: false,
    topicSport: false,
    topicVegetarian: false,
    topicVegan: false,
    topicWeight: false,
    topicEasyBirth: false,
    familyOption: '',
    textareaValue: '',
    textWorkValue: '',
    name: "",
    email: "",
    email_contact: false,
    newsletter: false,
    setFormData: (name, value) => {
        set({
            [name]: value
        })
    }
}))

export const useFormData = () => useStore((state: FullState) => state, shallow)